import React from "react";
import { Modal } from "react-bootstrap";
import Markdown from "react-markdown";

function DocumentBody({ body }) {
  return (
    <div className="document-body">
      <Markdown children={body} />
    </div>
  );
}

export default DocumentBody;
